import axios from 'axios';
import authService from './authService';
import CustomError from './customError';
import { baseUrls } from '../const/baseUrl';
import bearerToken from '../utils/getBearerToken';
import { getAccessToken } from '../utils/getAccessToken';
import { isArray } from '../utils/getTypeofItem';
import { searchParamsFromURL } from '../utils/searchParamsFromURL';
import { getCookieValue } from '../utils/cookieValue';

class FetchService {
  constructor() {
    this.delegationToken = null;
    this.mapboxAccessToken = getAccessToken();
    this.UrlAuthManager = baseUrls().UrlAuthManager;
    this.UrlUniversalLabel = baseUrls().UrlUniversalLabel;
    this.UrlWebApi = baseUrls().UrlWebApi;
    this.UrlMapboxGeocoding = baseUrls().UrlMapboxGeocoding;
    this.adapter = axios.create({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  }

  doRequest = async ({ baseURL, headers, options }) => {
    try {
      const response = await this.adapter.request({
        ...options,
        baseURL,
        headers,
      });
      const { data } = await response;
      return data;
    } catch (e) {
      if (e.response) {
        const {
          data,
          data: { errors },
        } = e.response;
        if (isArray(errors)) {
          const { technical_details: { code, reason } = {} } = errors[0] || {};
          let { description = '' } = errors[0] || {};
          if (!!code && !!reason) throw new CustomError(description, { cause: { code, reason } });

          if (!description?.length) description = errors[0];
          if (description?.length) throw new Error(description);
        }
        throw new Error(errors || data);
      }
      throw e;
    }
  };

  getResource = async options => {
    const baseURL = this.UrlAuthManager;
    const headers = {};
    return await this.doRequest({ baseURL, headers, options });
  };

  getPickupLocation = async options => {
    const baseURL = this.UrlWebApi;
    const headers = {};
    return await this.doRequest({ baseURL, headers, options });
  };

  getWebApiResource = async options => {
    if (!this.delegationToken) {
      this.delegationToken = authService.getDelegationToken();
      if (!this.delegationToken) return false;
    }

    const baseURL = this.UrlWebApi;
    const headers = {
      Authorization: bearerToken(this.delegationToken),
      'x-device-identifier': JSON.parse(localStorage.getItem('deviceId')) || null,
    };
    return await this.doRequest({ baseURL, headers, options });
  };

  getMapboxResource = async options => {
    if (!this.mapboxAccessToken) {
      this.mapboxAccessToken = getAccessToken();
      if (!this.mapboxAccessToken) return false;
    }
    const baseURL = this.UrlMapboxGeocoding;
    const { params } = options;
    options = { ...options, params: { ...params, access_token: this.mapboxAccessToken } };
    return await this.doRequest({ baseURL, options });
  };

  clearDelegationToken = () => {
    this.delegationToken = null;
  };
}

export default new FetchService();
